module.exports = __webpack_public_path__ + "img/gyro.ddbd474d.svg";